// extracted by mini-css-extract-plugin
export default {"theme1Primary":"#305dd2","theme2Primary":"#9c27b0","theme3Primary":"#ff9800","secondary":"#f50057","background":"#fafafa","error":"#d32f2f"};